<template>
  <div class="page-container" style="min-height: auto;">
    <Toast ref="toast" />

    <div class="page-title-container">
      <h1 class="title-text">Admin Suggested Sites</h1>
    </div>

    <div class="center-items">
      <button class="primary-button" @click="$router.push({ path: '/admin' })">⬅️ Back to Admin</button>
    </div>

    <h1 v-if="suggestedSites.length === 0">Nothing found.</h1>

    <div v-if="suggestedSites.length !== 0" class="feature admin-dashboard-container" style="background-color: var(--secondary-color);">
      <div class="feature admin-dashboard-container" v-for="site in suggestedSites" :key="site">
        <div class="feature admin-dashboard-container"><b>Site Name</b> {{ site.siteName }}</div>

        <div class="feature admin-dashboard-container"><b>Description</b> {{ site.description }}</div>
        <div class="feature admin-dashboard-container"><b>People</b>{{ site.people }}</div>
        <div class="feature admin-dashboard-container"><b>Niche</b>{{ site.niche }}</div>
        <div class="feature admin-dashboard-container">
          <b>Link</b>
          <a :href="site.link">{{ site.siteUrl }}</a>
        </div>
        <div class="feature admin-dashboard-container"><b>Location</b>{{ site.where }}</div>
        <div class="feature admin-dashboard-container"><b>Reason</b>{{ site.why }}</div>
        <div class="feature admin-dashboard-container"><b>Tags</b>{{ site.tags }}</div>
        <div class="center-items" style="margin:0rem;">
          <button @click="remove(site.id)" class="secondary-button small-button" type="button">Remove</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";

import Toast from "@/components/Toast";

export default {
  components: {
    Toast,
  },

  data() {
    return {
      suggestedSites: [],
    };
  },

  created() {
    window.scrollTo(0, 0);

    this.refresh();
  },

  methods: {
    refresh() {
      this.suggestedSites = [];
      firebase.firestore
        .collection("suggest-site")
        .get()
        .then((snapshot) => {
          snapshot.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            this.suggestedSites.push(data);
          });
        })
        .catch((error) => {
          console.error("Error getting documents: ", error);
        });
    },

    accept(site) {
      this.$router.push({ path: `/admin-suggested-site-detail/${site.id}` });
    },

    async remove(id) {
      try {
        await firebase.functions.httpsCallable("removeSuggestedSite")({
          id,
        });
        this.$refs.toast.show("Deleted");
      } catch (error) {
        console.error(error.message);
        this.$refs.toast.show(error.message);
      }

      this.refresh();
    },
  },
};
</script>

<style scoped></style>
